import { ShoppingCartProduct } from './shopping-cart-product';
import { TransactionSummary } from './transaction-summary';

export class ShoppingCart {
	cardName: string;
	cardNumber: string;
	cardExpMM: string;
	cardExpYY: string;
	guestId: number;
	guestName: string;
	guestEmail: string;
	locationId: number;
	departmentId: number;
	siteId: number;
	registerId: number;
	sourceId: number;
	registerName: string;
	grandTotal: number;
	discountTotal: number;
	membershipOrderId: number;
	orderId: number;
	orderSourceId: number;
	orderStatusId: number;
	membershipDiscount: number;
	transactionId: number;
	employeeId: number;
	transactionSourceType: string;
	transactionSourceTypeId: number;
	discountCode: string;
	isOpenSelectInventorySitePopup: boolean;
	ipAddress: string;
	isAllowPriceOverride: boolean;
	products: ShoppingCartProduct[];
	tipAmount: number;
	eventDiscount: number;
	isTicketType: boolean;
	isContainsPdf: boolean;
	paymentDone: boolean = false;

	transactionFees: TransactionSummary;

	get subTotal(): number {
		const self = this;

		let ttl = 0;
		self.products.forEach(function (product) {
			ttl += (product.quantity * product.price || 0);
			if (product.selectedModifiers && product.selectedModifiers.length) {
				product.selectedModifiers.forEach(sm => {
					ttl += product.quantity * (sm.priceAdjustment || 0);
				});
			}
		});

		return this.round(ttl);
	}
	// this is only here to keep the data service from crashing when it tries to assign to this property
	set subTotal(val: number) { }

	get taxTotal(): number {
		const self = this;

		let noSessionProductsTax = 0;
		let sessionProductsTax = 0;
		let modifierProductsTax = 0;
		let transactionTaxTotal = 0;

		//don't calculate tax by quantity for session products or modifier because the api already does that for us 
		self.products.filter(p => p.isSessionProduct == true).forEach(function (product) {
			sessionProductsTax += (product.taxAmount || 0);
		});

		self.products.filter(p => p.isSessionProduct == false && p.modifierIds).forEach(function (product) {
			let modifierPrice = (product.price || 0);
			if (product.selectedModifiers && product.selectedModifiers.length) {
				product.selectedModifiers.forEach(sm => {
					modifierPrice += (sm.priceAdjustment || 0);
				});
			}
			modifierProductsTax += (product.quantity * (modifierPrice * product.taxRate) || 0);
		});

		self.products.filter(p => p.isSessionProduct == false && !p.modifierIds).forEach(function (product) {
			noSessionProductsTax += (product.quantity * (product.price * product.taxRate) || 0);
		});

		// calculate total transaction fee tax for each transaction fee
		 if (self.transactionFees) {
			return self.transactionFees.taxTotal;
		}

		return this.round(sessionProductsTax + noSessionProductsTax + modifierProductsTax + transactionTaxTotal);
	}
	// this is only here to keep the data service from crashing when it tries to assign to this property
	set taxTotal(val: number) { }

	get total(): number {
		// If transactionFees is set, use its grandTotal
		if (this.transactionFees && this.transactionFees.grandTotal !== undefined) {
			return this.round(this.transactionFees.grandTotal);
		}

		// Otherwise calculate from subTotal and taxTotal
		return this.round(this.subTotal + this.taxTotal);
	}
	// this is only here to keep the data service from crashing when it tries to assign to this property
	set total(val: number) { }

	get cartItems(): number {
		const self = this;
		let items = 0;

		self.products.forEach(function (product) {
			items += product.quantity;
		});

		return items;
	}
	// this is only here to keep the data service from crashing when it tries to assign to this property
	set cartItems(val: number) { }

	constructor() {
		this.products = [];
	}

	private round(value: any): number {
		if (value === undefined || value === '' || value === null) {
			return value;
		}

		if (isNaN(value)) {
			value = value.replace(/[^0-9\.]+/g, '');
		}

		return Number(Math.round(Number(value + 'e' + 2)) + 'e-' + 2);
	}
}
